import { AdmissionsScreen } from "./AdmissionsScreen";

export default AdmissionsScreen;
